"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalContext = void 0;
const react_1 = require("react");
function useLocalContext(data) {
    const [ctx] = (0, react_1.useState)({});
    Object.keys(data).forEach(key => {
        ctx[key] = data[key];
    });
    return ctx;
}
exports.useLocalContext = useLocalContext;
//# sourceMappingURL=useLocalContext.js.map